import store from '@/store'

export default async (to, from, next) => {
    let order = await store.getters["order/pending_order"];
    if (!order.type_id) {
        next({ name: 'province' });
    }
    next();


}
